import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCalculationFields } from "@ploy-lib/calculation";
import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
import { makeStyles, createStyles, Grid, Typography, Divider } from "@material-ui/core";
import clsx from "clsx";
import { fieldToKey } from "../../utils";
addRegisteredSectionLayout({
    name: "CustomerInfoSection",
    displayName: "CustomerInfoSection",
    settings: {}
});
const CustomerInfoSection = (props) => {
    const { fields, onClick, useSeparator, sectionTitle, className } = props;
    const classes = useStyles(props);
    const calculationFields = useCalculationFields(...fields);
    return (_jsxs(Grid, { container: true, className: clsx(classes.root, className), onClick: onClick, children: [sectionTitle && (_jsx(Grid, { item: true, xs: 12, children: _jsx(Typography, { variant: "caption", children: sectionTitle }) })), calculationFields.map((field, i) => {
                const isLeftSide = i % 2 === 0;
                return (_jsx(Grid, { item: true, xs: 6, className: clsx(classes.fieldContainer, !isLeftSide && classes.fieldContainerRight, calculationFields.length === 1 && classes.fieldContainerSingleItem), children: _jsx(Typography, { className: clsx(i === 0 && classes.itemFirst, isLeftSide && classes.itemLeft), variant: "body2", children: field &&
                            (field.value?.toString() ?? field.fieldValue?.toString()) }) }, fieldToKey(fields[i])));
            }), useSeparator && (_jsx(Grid, { item: true, xs: 12, style: { paddingTop: 16 }, children: _jsx(Divider, { orientation: "horizontal" }) }))] }));
};
CustomerInfoSection.displayName = "DployCustomerInfoSection";
const useStyles = makeStyles((theme) => createStyles({
    root: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1)
    },
    fieldContainer: {
        marginTop: theme.spacing(1),
        display: "flex"
    },
    fieldContainerRight: {
        justifyContent: "flex-end",
        textAlign: "right"
    },
    fieldContainerSingleItem: {
        maxWidth: "100%",
        flexBasis: "100%"
    },
    itemLeft: {
        fontWeight: "bold"
    },
    itemFirst: {
        fontSize: "1.1rem"
    }
}), { name: "DployCustomerInfoSection" });
export { CustomerInfoSection };
//# sourceMappingURL=CustomerInfoSection.js.map